"use client";

import styled from "styled-components";

export const List = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  display: block;
  font-family: "Roboto Light";
  font-size: 13px;
  color: var(--textLight);
  margin-bottom: 5px;
  position: relative;
  padding-left: 15px;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 5px;
    background-color: var(--textLight);
    border-radius: 50%;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
